// Single source of truth for the 4 wellness pillar DISPLAY labels.
//
// IMPORTANT: these are display-only. The backend (and all routing/data) always
// keys the pillars as `movement` / `recovery` / `mental` / `nutrition`.
// Changing a label here NEVER affects routing, scoring, or any API/data flow.

export const PILLAR_LABELS = {
  movement:  'Move',
  recovery:  'Recover',
  mental:    'Mind',
  nutrition: 'Fuel',
};

// Longer descriptive names — for page subtitles / formula labels (not nav).
export const PILLAR_FULL = {
  movement:  'Movement',
  recovery:  'Recovery',
  mental:    'Mental readiness',
  nutrition: 'Nutrition',
};
